import { render, staticRenderFns } from "./DocumentListItem.vue?vue&type=template&id=b1ce048c&scoped=true&"
import script from "./DocumentListItem.vue?vue&type=script&lang=js&"
export * from "./DocumentListItem.vue?vue&type=script&lang=js&"
import style0 from "./DocumentListItem.vue?vue&type=style&index=0&id=b1ce048c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ce048c",
  null
  
)

export default component.exports